module.exports = __webpack_public_path__ + "img/entities.a18dfdf9.svg";